export const dataControlStyle: any = {
    fill: 'rgba(255, 255, 255, 0)',
    stroke: '#000000',
    strokeWidth: 2
};